<template>
  <el-row type="flex" justify="center">
    <el-col :sm="24" :md="16">
      <ra-card :header="false">
        <template slot="content">
          <div class="documentation">
            <p class="documentation-text">
              We have provided documentation resources to cover for all products
              in Radius. You can access the docs and use APIs for your specific
              use cases.
            </p>
            <img
              class="documentation-image"
              :src="getImage('stopwatch.png')"
              alt="IMG"
              height="100"
              width="100"
            />
            <div class="documentation-action">
              <el-button type="primary" @click="viewDocs">Check Docs</el-button>
            </div>
          </div>
        </template>
      </ra-card>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: "DevelopersDoc",
  methods: {
    viewDocs() {
      window.open("https://documenter.getpostman.com/view/15324321/TzJoDLJB");
    }
  }
};
</script>

<style lang="scss" scoped>
.documentation {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 40px 0;
  text-align: center;

  &-text {
    font-size: 1rem;
    width: 40%;
  }

  &-image {
    margin: 20px 0;
  }

  &-action {
    .link-normal {
      cursor: pointer;
      color: var(--ra-red-primary);
      font-weight: 500;
    }
  }
}
</style>
